










import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import { Company, Office, getOtherCompanies } from "@/api/company-api";
import { StaffTableItem } from "@/components/VStaffTable.vue";

import CompanyShow from "@/templates/CompanyShow.vue";

@Component({
  components: {
    CompanyShow
  }
})
export default class CompanyShowPage extends Vue {
  @Prop({ required: true }) id!: string;
  query = "";

  created() {
    this.initCompanies();
  }

  edit() {
    const params = { id: this.id };
    this.$router.push({ name: "companies-edit", params });
  }
  search(query: string) {
    this.query = query;
  }

  cancel() {
    this.$router.push({ name: "companies-list" });
  }

  createStaff() {
    const params = { companyId: this.id };
    this.$router.push({ name: "company-staffs-new", params });
  }

  selectStaff(id: number) {
    const params = { companyId: this.id, id: String(id) };
    this.$router.push({ name: "company-staffs-edit", params });
  }

  private companies: Company[] = [];
  company: Company | null = null;
  office: Office | null = null;
  private staffs: StaffTableItem[] = [];

  get staffItems(): StaffTableItem[] {
    if (!this.query) return this.staffs;
    return this.staffs.filter(s => s.name.includes(this.query));
  }

  private async initCompanies() {
    this.companies = await getOtherCompanies();
    this.selectCompany();
  }

  @Watch("id")
  private selectCompany() {
    const c = this.companies.find(c => String(c.companyId) === this.id);
    if (c) {
      this.company = { ...c };
      this.office = { ...c.office };
      this.staffs = c.office.staffList.map(
        s => new StaffTableItem(s, c || undefined)
      );
    } else {
      this.company = null;
      this.office = null;
      this.staffs = [];
    }
  }
}
